import { createFileRoute } from '@tanstack/react-router'
import { ReferralsPage } from '@/features/referrals/components/referrals-page'

export const Route = createFileRoute('/_app/_auth/dashboard/_layout/referrals')(
  {
    component: ReferralsPage,
    beforeLoad: () => ({
      title: 'Referrals',
      headerTitleKey: 'header.referrals.title',
      headerDescriptionKey: 'header.referrals.description',
    }),
  },
)
